import { TaizhouApplicationList, HaiShuApplicationList, HuangYanApplicationList, YiWuApplicationList, ApplicationList, ApplicationDetail, OfficialList, NewestList, LikeList, MyAppList, SolutionList } from '@/services/application'

const state = {
  applicationList: [],
  TaizhouapplicationList: [],
  HuangYanApplicationList: [],
  YiWuApplicationList: [],
  HaiShuApplicationList: [],
  solutionList: [],
  pagination: {
    page: 1,
    pageSize: 12,
    count: 0
  },
  Taizhoupagination: {
    page: 1,
    pageSize: 12,
    count: 0
  },
  HaungYanpagination: {
    page: 1,
    pageSize: 12,
    count: 0
  },
  YiWupagination: {
    page: 1,
    pageSize: 12,
    count: 0
  },
  HaiShupagination: {
    page: 1,
    pageSize: 12,
    count: 0
  },
  planpagination: {
    page: 1,
    pageSize: 6,
    count: 0
  },
  applicationDetail: {},
  officialList: [],
  newestList: [],
  likeList: [],
  myAppList: [],
  activeName: ''
}

const mutations = {
  updateApplicationList (state, { payload }) {
    state.applicationList = payload.list
    state.pagination = {
      page: payload.page,
      pageSize: 12,
      count: payload.count
    }
  },
  updateTaizhouApplicationList (state, { payload }) {
    state.TaizhouapplicationList = payload.list
    state.Taizhoupagination = {
      page: payload.page,
      pageSize: 12,
      count: payload.count
    }
  },
  updateHuangYanApplicationList (state, { payload }) {
    state.HuangYanApplicationList = payload.list
    state.HaungYanpagination = {
      page: payload.page,
      pageSize: 12,
      count: payload.count
    }
  },
  updateYiWuApplicationList (state, { payload }) {
    state.YiWuApplicationList = payload.list
    state.YiWupagination = {
      page: payload.page,
      pageSize: 12,
      count: payload.count
    }
  },
  updateHaiShuApplicationList (state, { payload }) {
    state.HaiShuApplicationList = payload.list
    state.HaiShupagination = {
      page: payload.page,
      pageSize: 12,
      count: payload.count
    }
  },
  updateSolutionList (state, { payload }) {
    state.solutionList = payload.list
    state.planpagination = {
      page: payload.page,
      pageSize: 6,
      count: payload.count
    }
  },
  updateApplicationDetail (state, { payload }) {
    state.applicationDetail = payload
  },
  updateOfficial (state, { payload }) {
    state.officialList = payload
  },
  updateNewest (state, { payload }) {
    state.newestList = payload
  },
  updateLike (state, { payload }) {
    state.likeList = payload
  },
  updateMyAppList (state, { payload }) {
    state.myAppList = payload
  }
}

const actions = {
  async fetchApplicationList ({ commit, state }, payload) {
    const response = await ApplicationList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateApplicationList', payload: response.data })
    }
  },
  async fetchTaizhouApplicationList ({ commit, state }, payload) {
    const response = await TaizhouApplicationList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateTaizhouApplicationList', payload: response.data })
    }
  },
  async fetchYiWuApplicationList ({ commit, state }, payload) {
    const response = await YiWuApplicationList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateYiWuApplicationList', payload: response.data })
    }
  },
  async fetchHaiShuApplicationList ({ commit, state }, payload) {
    const response = await HaiShuApplicationList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateHaiShuApplicationList', payload: response.data })
    }
  },
  async fetchHuangYanApplicationList ({ commit, state }, payload) {
    const response = await HuangYanApplicationList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateHuangYanApplicationList', payload: response.data })
    }
  },
  async fetchApplicationDetail ({ commit, state }, payload) {
    const response = await ApplicationDetail(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateApplicationDetail', payload: response.data })
    }
  },
  async fetchOfficialList ({ commit, state }, payload) {
    const response = await OfficialList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateOfficial', payload: response.data && response.data.list })
    }
  },
  async fetchNewestList ({ commit, state }, payload) {
    const response = await NewestList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateNewest', payload: response.data && response.data.list })
    }
  },
  async fetchLikeList ({ commit, state }, payload) {
    const response = await LikeList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateLike', payload: response.data && response.data.list })
    }
  },
  async fetchMyAppList ({ commit, state }, payload) {
    const response = await MyAppList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateMyAppList', payload: response.data && response.data.list })
    }
  },
  async fetchSolutionList ({ commit, state }, payload) {
    const response = await SolutionList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateSolutionList', payload: response.data })
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/application.js